import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createDefaultEmailTemplatesAsync, getEmailTemplateByContextAsync, getEmailTemplateByIdAsync, getEmailTemplatesByEventIdAsync, getEventEmailTemplatesAsync, toggleEmailTemplatesByEventAndTypeAsync, upsertEmailTemplateAsync } from './emailTemplatesThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const emailTemplatesSlice = createSlice({
    name: 'emailTemplates',
    initialState,
    reducers: {
        resetEmailTemplatesApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearSelectedEmailTemplate(state) {
            state.selectedEmailTemplate = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(upsertEmailTemplateAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(upsertEmailTemplateAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedEmailTemplate = action.payload;
            if (!state.emailTemplates) {
                state.emailTemplates = [action.payload];
                return;
            }
            const index = state.emailTemplates.findIndex((template) => template.id === action.payload.id);
            if (index >= 0) {
                state.emailTemplates[index] = action.payload;
            }
            else {
                state.emailTemplates.push(action.payload);
            }
        })
            .addCase(upsertEmailTemplateAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getEmailTemplatesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmailTemplatesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.emailTemplates = action.payload;
        })
            .addCase(getEmailTemplatesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getEmailTemplateByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmailTemplateByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedEmailTemplate = action.payload;
        })
            .addCase(getEmailTemplateByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getEmailTemplateByContextAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmailTemplateByContextAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedEmailTemplate = action.payload;
        })
            .addCase(getEmailTemplateByContextAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getEventEmailTemplatesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventEmailTemplatesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventEmailTemplates = action.payload;
        })
            .addCase(getEventEmailTemplatesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(toggleEmailTemplatesByEventAndTypeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(toggleEmailTemplatesByEventAndTypeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.emailTemplates) {
                action.payload.forEach((updated) => {
                    const index = state.emailTemplates.findIndex((t) => t.id === updated.id);
                    if (index >= 0) {
                        state.emailTemplates[index] = updated;
                    }
                });
            }
        })
            .addCase(toggleEmailTemplatesByEventAndTypeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(createDefaultEmailTemplatesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createDefaultEmailTemplatesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.emailTemplates = action.payload;
        })
            .addCase(createDefaultEmailTemplatesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetEmailTemplatesApiState, clearSelectedEmailTemplate } = emailTemplatesSlice.actions;
export default emailTemplatesSlice.reducer;
